import React from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import axiosHandler from "../../../utils/axiosHandler.ts";

//import page from federation pages
import { CustomerInvoiceSummaryPage } from "../../../federation/pages";

const CustomerInvoiceSummary = () => {
  const navigate = useNavigate();

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <CustomerInvoiceSummaryPage
        axiosHandler={axiosHandler}
        navigate={navigate}
      />
      {/* <OrderEntryPage /> */}
    </React.Suspense>
  );
};

export default CustomerInvoiceSummary;
